import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { appGuard } from './core/guard/app.guard';
import { ROLES } from './core/constants/user.const';

export const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [appGuard],
    data: { roles: [ROLES.ADMIN] },
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/dashboard/dashboard.routes').then((m) => m.routes),
      },
      {
        path: 'users',
        loadChildren: () => import('./modules/user/user.routes').then((m) => m.routes),
      },
      {
        path: 'alerts',
        loadChildren: () => import('./modules/incident/incident.routes').then((m) => m.routes),
      },
      {
        path: 'chats',
        loadChildren: () => import('./modules/chat/chat.routes').then((m) => m.routes),
      },
      {
        path: 'institutions',
        loadChildren: () => import('./modules/institution/institution.routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: '404',
    loadComponent: () => import('./modules/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
];
